import React from "react";
import KosherInfoContainer from "../../../components/Compliance Certificates/KOSHER/KosherInfoContainer";
import KosherHeader from "../../../components/Compliance Certificates/KOSHER/KosherHeader";

const Kosher = () => {
  return (
    <div>
      <KosherHeader />
      <KosherInfoContainer />
    </div>
  );
};

export default Kosher;
